
/**
 * To disable merge case functionality in subcase level
 * @param metaData case metadata
 * @returns 
 */
export const IsDisabledMergeCaseItem = (metaData: any): boolean => {
  const { entityType, parentCaseId } = metaData
  return entityType === "S" && parentCaseId > 0
}